module.exports = __webpack_public_path__ + "assets/media/lunch.80e3d56d.mp3";